"use strict";
/****************************************************
 * Audit Information Platform Component
 * 工具条
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
/**
 * 任务栏组件
 *
 */
var Toolbar = function (props) {
    return (React.createElement("div", null,
        React.createElement(tinper_bee_1.ButtonGroup, { className: "toolbarbuttongroup", size: "sm" }, props.children)));
};
exports.default = Toolbar;
